import React, { useEffect, useState } from 'react';

const FadeInTransition = ({ start, end, playedMs }) => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    let newOpacity = 0;
    if (playedMs >= start) {
      newOpacity = ((playedMs - start) * 0.4) / 100;
      if (playedMs >= end) {
        newOpacity = 1;
      }
    }
    setOpacity(newOpacity);
  }, [playedMs, start, end]);

  return (
    <div
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        opacity,
        backgroundColor: '#000000',
        borderRadius: '8px',
      }}
    ></div>
  );
};

export default FadeInTransition;
